import React from 'react';
import PropTypes from 'prop-types';
import ConnectButton from '../../../pages/_banner/ConnectButton';
import Wrapper from '../../../pages/_banner/Wrapper';
import useDialogLauncher from '../../_hooks/useDialogLauncher';
import { DialogManager } from '../../../dialogs_new/DialogManager';
import useRouter from '../../../hooks/useRouter';

ExpiredBanner.propTypes = {
  project: PropTypes.object.isRequired
};

export default function ExpiredBanner(props) {
  const { project, creator } = props;

  const launch = useDialogLauncher();
  const { history } = useRouter();

  // function onEdit() {
  //   launch(DialogManager.ProjectManage.Config(project.id, '/manage'));
  // }

  function onCloseExtend() {
    launch(DialogManager.ProjectCloseExtend.Config(project.id));
  }

  return (
    <Wrapper
      color="blue"
      creator={creator}
      title={(
        <>
          Your project timeline has ended.
        </>
      )}
      subtitle={(
        <>
          Partners can no longer see your project because it's set in the past. Update
          your timeline to make it visible again or close your event.
        </>
      )}
    >
      <div className="flex flex-col sm:flex-row space-x-0 space-y-4 sm:space-x-4 sm:space-y-0">
        {/*<ConnectButton outline={true} onClick={() => history.push('/manage')}>*/}
        {/*  Update timeline*/}
        {/*</ConnectButton>*/}
        <ConnectButton color="blue" onClick={onCloseExtend}>
          Close or extend date
        </ConnectButton>
        {/*<ConnectButton disabled={true}>*/}
        {/*  This is you*/}
        {/*</ConnectButton>*/}
      </div>
    </Wrapper>
  );
};
